import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { OrderSummaryRow } from "./OrderSummaryRow";
import { isValidArray, scrollToTop } from "../../Layout/Common/common";
import { Coupon } from "./Coupon";
import Skeleton from "react-loading-skeleton";
import { OrderSummaryRowSkeleton } from "../../Skeleton/OrderSummaryRowSkeleton";
import { OrderSummaryList } from "./OrderSummaryList";
import { useAuth } from "../../Context/AuthContext";
import { axiosInstance } from "../../axios/axiosInstance";
import { SHIPPING_METHOD } from "../../constants";
import { useParams } from "react-router-dom";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";

export const OrderSummary = () => {
  const { userId } = useAuth();
  const [cartItem, setCartItem] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [checkoutData, setCheckoutData] = useState(null);
  const globalcontext = useContext(GlobalContext);
  const { deliveryMethod, promoCode } = useContext(GlobalContext);
  const { orderId: urlOrderId } = useParams();
  const { getOrderItems } = useGlobalFunction();

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (urlOrderId) {
        const response = await getOrderItems(urlOrderId);
        if (cancelled) return;
        if (response && isValidArray(response.cartItem)) {
          setCartItem(response);
          setOrderId(urlOrderId);
        }
        return;
      }
      if (globalcontext.CartItem && isValidArray(globalcontext.CartItem.cartItem)) {
        setCartItem(globalcontext.CartItem);
        setOrderId(globalcontext.CartItem.orderid);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [urlOrderId, globalcontext.CartItem]);
  useEffect(() => {
    if (orderId) CalculateTax();
  }, [orderId, globalcontext.shippingCost, globalcontext.CartItem, promoCode]);

  const CalculateTax = () => {
    var shippCost = parseFloat(globalcontext.shippingCost);
    if (isNaN(shippCost) || shippCost == null) {
      shippCost = 0;
    }
    if (promoCode && promoCode.shipcode == "DELFREE") {
      shippCost = 0;
    }
    var par = {
      userId: String(userId),
      ShipCost: String(shippCost),
      OrderID: String(orderId),
    };

    axiosInstance
      .post("Shipping/CalculateTax", par)
      .then((response) => {
        if (response.data != "") {
          globalcontext.setNetAmount(parseFloat(response.data.NetAmount).toFixed(2));
          globalcontext.setTotalTax(parseFloat(response.data.TaxAmount).toFixed(2));
        }
      })
      .catch((error) => console.log(error.message));
    loadCheckoutDetails();
  };

  const loadCheckoutDetails = async () => {
    var par = {
      userId: String(userId),
      orderId: String(orderId),
    };
    const result = await axiosInstance.post("Shipping/loadCheckoutDetails", par);
    if (result && result.data) {
      setCheckoutData(result.data);
    }
  };

  return (
    <div className="col-md-5 col-lg-5 rht-summary">
      <div className="checkout-orderSummary">
        <div className="wesproduct-title checkout-title">
          <h3>Order Summary</h3>
        </div>
        <OrderSummaryRow cartItem={cartItem} />
        <div className="order-summary-total">
          <div className="orderSummary-list">
            <OrderSummaryList label={"Sub Total"} value={cartItem && cartItem.totalcost} />
            {deliveryMethod == SHIPPING_METHOD[1] && (
              <>
                {globalcontext.shippingCode == "TBA" ? (
                  <OrderSummaryList label={"Shipping"} value={"TBA"} />
                ) : (
                  <OrderSummaryList label={"Shipping"} value={globalcontext.shippingCost} />
                )}
              </>
            )}
            <Coupon />
            <OrderSummaryList label={"Tax Amount"} value={globalcontext.totalTax} />
          </div>
          <div className="orderSummary-total">
            <div className="order-summary-list">
              <p>Total</p>
              {globalcontext.shippingCode == "TBA" ? (
                <span>TBA</span>
              ) : globalcontext.netAmount ? (
                <span>${globalcontext.netAmount}</span>
              ) : (
                <Skeleton width={50} height={28} />
              )}
            </div>
          </div>
          <div></div>
        </div>
        {checkoutData && (
          <Fragment>
            <table style={{ color: "transparent", fontSize: "12px" }}>
              <tbody>
                <tr>
                  <td>Order Id: </td>
                  <td>{String(orderId)}</td>
                </tr>
                <tr>
                  <td>Weight: </td>
                  <td>{checkoutData.totalWeight}</td>
                </tr>
                <tr>
                  <td>Zone: </td>
                  <td>{checkoutData.zone}</td>
                </tr>
                <tr>
                  <td>PPP Cyper: </td>
                  <td>{String(checkoutData.isppp_cyperpower)}</td>
                </tr>
                <tr>
                  <td>PPP: </td>
                  <td>{String(checkoutData.isppp)}</td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        )}
      </div>
    </div>
  );
};
